var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("h2", [_vm._v("App Version")]),
    _vm._v(" "),
    _c(
      "form",
      [
        _c("div", { staticClass: "row row-clear-md-4" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              { class: ["form-group", _vm.errorClass("ios_minimum_version")] },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("iOS Minimum Version"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.stateIosMinimumVersion,
                      expression: "stateIosMinimumVersion",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { name: "ios_minimum_version", type: "text" },
                  domProps: { value: _vm.stateIosMinimumVersion },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.stateIosMinimumVersion = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("help-block", { attrs: { field: "ios_minimum_version" } }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              {
                class: [
                  "form-group",
                  _vm.errorClass("android_minimum_version"),
                ],
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("Android Minimum Version"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.stateAndroidMinimumVersion,
                      expression: "stateAndroidMinimumVersion",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { name: "android_minimum_version", type: "text" },
                  domProps: { value: _vm.stateAndroidMinimumVersion },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.stateAndroidMinimumVersion = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("help-block", {
                  attrs: { field: "android_minimum_version" },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "div",
              { class: ["form-group", _vm.errorClass("app_minimum_version")] },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("App Minimum Version"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.stateAppMinimumVersion,
                      expression: "stateAppMinimumVersion",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { name: "app_minimum_version", type: "text" },
                  domProps: { value: _vm.stateAppMinimumVersion },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.stateAppMinimumVersion = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("help-block", { attrs: { field: "app_minimum_version" } }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "ladda-button",
          {
            staticClass: "btn btn-success",
            attrs: { click: _vm.handleSaveAppVersionSettings },
          },
          [
            _c("i", { staticClass: "fa fa-check" }),
            _vm._v(" Save Changes\n    "),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }